import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { ApicallService } from '../../services/apicall.service';

import * as _moment from 'moment';
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})
export class DatePickerComponent implements OnInit {

  minDateValue: any;
  maxDateValue: any;

  @Input('pickerType') pickerType;
  @Input('datelabel') datelabel;
  @Input() set initDate(value: any) {
    if (value != undefined) {
      this.date =new UntypedFormControl(moment(value));
    }
  }

  @Input() set minDate(value: any) {
    if (value != undefined) {
      value = value.split("-").map(iNum => parseInt(iNum, 10));;
      this.minDateValue = new Date(value[0], value[1]-1, value[2]);
    }
  }

  @Input() set maxDate(value: any) {
    if (value != undefined) {
      value = value.split("-").map(iNum => parseInt(iNum, 10));;
      this.maxDateValue = new Date(value[0], value[1]-1, value[2]);
    }
  }
  @Input('enableClear') enableClear;

  @Output() dateChanged: EventEmitter<any> =   new EventEmitter();
  
  date: any;

  constructor(
    public apiCallService:ApicallService
  ) { }

  ngOnInit() {
    if(this.apiCallService.globalDate != undefined){
      this.date = this.apiCallService.globalDate;
    }
    if(this.apiCallService.globalDate == undefined){
      this.date = new UntypedFormControl(moment(null));
    }
    this.dateModified(moment(this.date.value._d).clone().format('YYYY-MM-DD'));
  }
  

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    const date = moment(event.value).clone().format('YYYY-MM-DD');
    // this.apiCallService.globalDate = this.date; 
    this.dateModified(date)
  }

  dateModified(date){
    this.dateChanged.emit(date); 
  }

  clearData(data){
    this.date = new UntypedFormControl(moment(null));
    this.dateChanged.emit(null); 
  }
}
